import { render, staticRenderFns } from "./modal-form.vue?vue&type=template&id=735ad2e1&"
import script from "./modal-form.vue?vue&type=script&lang=js&"
export * from "./modal-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports